import React, { useRef, useState } from "react";
import {
  formatRupiahTerbilang,
  capitalizeSentences,
  getNamaHari,
  getTanggalLengkap,
} from "../../util/function";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const FormContract = ({
  dataUser,
  dateFrom,
  setDateFrom,
  dateUntil,
  setDateUntil,
  posisi,
  setPosisi,
  umur,
  setUmur,
  handleKirim,
  isDisabled,
  setIsDisabled,
  isCreated,
}) => {
  const labelRef = useRef(null);
  const contractRef = useRef(null);
  const contractBodyRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const formatDot = (value) => {
    return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const data = {
    pihak1: {
      nama: "Tatang Suryanto",
      umur: "67 tahun",
      jabatan: "Ka. SDM",
    },
  };

  const gajiHarian = (dataUser?.basicSallary || 0) / 30;
  const namaPihakDua = capitalizeSentences(dataUser?.name) || "-";

  const fillInputStyle = {
    background: "transparent",
    border: "none",
    borderBottom: "1px dashed #B08D57",
    fontFamily: '"Times New Roman", serif',
    fontSize: "17px",
    color: "#1C2B39",
    padding: "0 2px",
    outline: "none",
  };

  const fillInputDisabledStyle = {
    ...fillInputStyle,
    borderBottom: "1px solid #D8D3C7",
    cursor: "not-allowed",
  };

  const handleDownloadPdf = async () => {
    const labelElement = labelRef.current;
    const bodyElement = contractRef.current;
    const bodyContentElement = contractBodyRef.current;
    if (!labelElement || !bodyElement || !bodyContentElement) return;

    setIsDownloading(true);

    const originalBodyFontSize = bodyElement.style.fontSize;
    const originalLabelFontSize = labelElement.style.fontSize;
    const originalBodyPadding = bodyContentElement.style.padding;
    const originalLabelPadding = labelElement.style.padding;

    bodyElement.style.fontSize = "17px";
    labelElement.style.fontSize = "15px";
    bodyContentElement.style.padding = "0 0 24px 0";
    labelElement.style.padding = "12px 0 0 0";

    try {
      const [labelCanvas, bodyCanvas] = await Promise.all([
        html2canvas(labelElement, {
          scale: 4,
          useCORS: true,
          backgroundColor: "white",
        }),
        html2canvas(bodyElement, {
          scale: 4,
          useCORS: true,
          backgroundColor: "white",
        }),
      ]);

      const labelImgData = labelCanvas.toDataURL("image/jpeg", 0.85);
      const bodyImgData = bodyCanvas.toDataURL("image/jpeg", 0.85);

      const pdf = new jsPDF("p", "mm", "legal");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const paddingPx = 240;
      const paddingMM = (paddingPx * 25.4) / 96;

      const labelWidthRatio = pdfWidth / labelCanvas.width;
      const labelRenderWidth = labelCanvas.width * labelWidthRatio;
      const labelRenderHeight = labelCanvas.height * labelWidthRatio;
      const labelMarginX = (pdfWidth - labelRenderWidth) / 2;

      pdf.addImage(
        labelImgData,
        "JPEG",
        labelMarginX,
        0,
        labelRenderWidth,
        labelRenderHeight,
        undefined,
        "FAST"
      );

      const availableHeight = pdfHeight - paddingMM;

      const bodyWidthRatio = pdfWidth / bodyCanvas.width;
      const bodyHeightRatio = availableHeight / bodyCanvas.height;
      const bodyScaleToFit = Math.min(bodyWidthRatio, bodyHeightRatio);

      const bodyRenderWidth = bodyCanvas.width * bodyScaleToFit;
      const bodyRenderHeight = bodyCanvas.height * bodyScaleToFit;
      const bodyMarginX = (pdfWidth - bodyRenderWidth) / 2;

      pdf.addImage(
        bodyImgData,
        "JPEG",
        bodyMarginX,
        paddingMM,
        bodyRenderWidth,
        bodyRenderHeight,
        undefined,
        "FAST"
      );
      const fileName = `Surat_Perjanjian_${
        dataUser?.name ? dataUser.name.replace(/\s+/g, "_") : "kontrak"
      }.pdf`;

      pdf.save(fileName);
    } catch (error) {
      console.error(error);
    } finally {
      bodyElement.style.fontSize = originalBodyFontSize;
      labelElement.style.fontSize = originalLabelFontSize;
      bodyContentElement.style.padding = originalBodyPadding;
      labelElement.style.padding = originalLabelPadding;
      setIsDownloading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "794px",
        margin: "16px auto",
        background: "white",
        boxShadow: "0 2px 14px rgba(28,43,57,0.10)",
        border: "1px solid #E4DFD3",
      }}
    >
      <div
        ref={labelRef}
        style={{
          padding: "12px 40px 0 40px",
          fontFamily: '"Times New Roman", serif',
        }}
      >
        <div
          style={{
            display: "inline-block",
            fontSize: "15px",
            letterSpacing: "1px",
            textTransform: "uppercase",
            padding: "12px 0 0 0",
            borderRadius: "20px",
            fontWeight: 550,
          }}
        >
          Form-HRD-A12-R0
        </div>
      </div>

      <div ref={contractRef}>
        <div
          ref={contractBodyRef}
          style={{
            margin: "0 auto",
            padding: "0 40px 24px 40px",
            color: "#1C2B39",
            fontFamily: '"Times New Roman", serif',
            fontSize: "17px",
            lineHeight: 1.3,
            textAlign: "justify",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              fontFamily: "Georgia, serif",
              fontWeight: "550",
              textDecoration: "underline",
              paddingBottom: "10px",
              margin: "10px 0 10px 0",
            }}
          >
            SURAT PERJANJIAN
          </h2>

          <p>
            Pada hari ini; {getNamaHari(dateFrom)} tanggal :{" "}
            {isCreated ? (
              <span>{getTanggalLengkap(dateFrom)}</span>
            ) : (
              <input
                type="date"
                style={fillInputStyle}
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
              />
            )}{" "}
            , Kami yang bertanda tangan di bawah ini :
          </p>

          {/* PIHAK I */}
          <table>
            <tbody>
              <tr>
                <td style={{ width: 30, padding: 0, borderBottom: 0 }}>I.</td>
                <td style={{ width: 120, padding: 0, borderBottom: 0 }}>
                  Nama
                </td>
                <td style={{ width: 20, padding: 0, borderBottom: 0 }}>:</td>
                <td style={{ padding: 0, borderBottom: 0 }}>
                  {data.pihak1.nama}
                </td>
              </tr>
              <tr>
                <td style={{ padding: 0, borderBottom: 0 }}></td>
                <td style={{ padding: 0, borderBottom: 0 }}>Umur</td>
                <td style={{ padding: 0, borderBottom: 0 }}>:</td>
                <td style={{ padding: 0, borderBottom: 0 }}>
                  {data.pihak1.umur}
                </td>
              </tr>
              <tr>
                <td style={{ padding: 0, borderBottom: 0 }}></td>
                <td style={{ padding: 0, borderBottom: 0 }}>Jabatan</td>
                <td style={{ padding: 0, borderBottom: 0 }}>:</td>
                <td style={{ padding: 0, borderBottom: 0 }}>
                  {data.pihak1.jabatan}
                </td>
              </tr>
            </tbody>
          </table>

          <p style={{ marginTop: "8px" }}>
            Dalam hal ini bertindak untuk dan atas nama PT TENAR INTI MANDIRI,
            selanjutnya dalam perjanjian ini disebut sebagai pihak I.
          </p>

          {/* PIHAK II */}
          <table>
            <tbody>
              <tr>
                <td style={{ width: 30, padding: 0, borderBottom: 0 }}>II.</td>
                <td style={{ width: 120, padding: 0, borderBottom: 0 }}>
                  Nama
                </td>
                <td style={{ width: 20, padding: 0, borderBottom: 0 }}>:</td>
                <td style={{ padding: 0, borderBottom: 0 }}>{namaPihakDua}</td>
              </tr>
              <tr>
                <td style={{ padding: 0, borderBottom: 0 }}></td>
                <td style={{ padding: 0, borderBottom: 0 }}>Umur</td>
                <td style={{ padding: 0, borderBottom: 0 }}>:</td>
                <td style={{ padding: 0, borderBottom: 0 }}>
                  {isCreated ? (
                    <>{umur} tahun</>
                  ) : (
                    <>
                      <input
                        type="text"
                        disabled={isCreated}
                        style={{
                          ...(isCreated
                            ? fillInputDisabledStyle
                            : fillInputStyle),
                          width: "18px",
                          borderBottom: 0,
                        }}
                        value={umur}
                        onChange={(e) => setUmur(e.target.value)}
                      />{" "}
                      tahun
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ padding: 0, borderBottom: 0 }}></td>
                <td style={{ padding: 0, borderBottom: 0 }}>Jabatan</td>
                <td style={{ padding: 0, borderBottom: 0 }}>:</td>
                <td style={{ padding: 0, borderBottom: 0 }}>
                  {isCreated ? (
                    posisi
                  ) : (
                    <input
                      type="text"
                      disabled={isCreated}
                      style={{
                        ...(isCreated
                          ? fillInputDisabledStyle
                          : fillInputStyle),
                        borderBottom: 0,
                      }}
                      value={posisi}
                      onChange={(e) => setPosisi(e.target.value)}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          <p style={{ marginTop: "8px" }}>
            Dalam hal ini bertindak untuk dan atas nama sendiri, selanjutnya
            dalam perjanjian ini disebut sebagai pihak II.
          </p>

          <p style={{ marginTop: "8px" }}>
            Kedua belah pihak sepakat untuk mengadakan perjanjian, dengan
            syarat-syarat sebagai berikut :
          </p>

          <h4
            style={{
              fontFamily: "Georgia, serif",
              fontWeight: "normal",
              letterSpacing: "0.5px",
              marginTop: "10px",
              marginBottom: "0",
            }}
          >
            PASAL I
          </h4>
          <div
            style={{ borderBottom: "1px solid #D8D3C7", marginBottom: "8px" }}
          />

          <ol style={{ marginTop: "6px" }}>
            <li>
              Pihak I sepakat menerima pihak II sebagai karyawan di PT. Tenar
              Inti Mandiri dengan status <strong>"KARYAWAN HARIAN"</strong>.
            </li>

            <li>
              Pihak I dan pihak II, sepakat mengadakan "Kontrak Kerja" terhitung
              mulai dari tanggal: {getTanggalLengkap(dateFrom)} sampai dengan
              tanggal{" "}
              {isCreated ? (
                <span>{getTanggalLengkap(dateUntil)}</span>
              ) : (
                <input
                  type="date"
                  style={fillInputStyle}
                  value={dateUntil}
                  onChange={(e) => setDateUntil(e.target.value)}
                />
              )}{" "}
              .
            </li>

            <li>
              Pihak I berhak menilai kinerja pihak II selama dalam masa kontrak,
              jika pihak II dinilai tidak sesuai dengan keinginan perusahaan,
              maka pihak I berhak memutuskan hubungan kerja walaupun masa
              kontrak belum berakhir.
            </li>

            <li>
              Pihak I dan pihak II sepakat untuk tidak mempunyai hubungan apapun
              setelah kontrak kerja ini berakhir.
            </li>
          </ol>

          <h4
            style={{
              fontFamily: "Georgia, serif",
              fontWeight: "normal",
              letterSpacing: "0.5px",
              marginTop: "10px",
              marginBottom: "0",
            }}
          >
            PASAL II
          </h4>
          <div
            style={{ borderBottom: "1px solid #D8D3C7", marginBottom: "8px" }}
          />

          <ol style={{ marginTop: "6px", marginBottom: "0px" }}>
            <li>
              Pihak I akan memberikan upah kerja kepada pihak II sebesar Rp.{" "}
              {formatDot(gajiHarian)},- {formatRupiahTerbilang(gajiHarian)}{" "}
              setiap hari, dan dibayar pada tanggal 15 dan 28 setiap bulannya.
            </li>

            <li>
              Jika pihak II tidak hadir dalam bekerja, maka pihak I tidak
              berkewajiban untuk membayar upah kerja kepada pihak II.
            </li>

            <li>
              Pihak I tidak berkewajiban untuk memberikan biaya pengobatan,
              perawatan atau santunan apapun, serta uang pesangon dan bonus
              kepada pihak II.
            </li>

            <li>
              Apabila terjadi perselisihan, maka kedua belah pihak sepakat untuk
              menyelesaikannya dengan cara musyawarah.
            </li>
          </ol>

          {/* Tanda tangan */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "4px",
              textAlign: "center",
            }}
          >
            <div>
              <div
                style={{
                  fontFamily: "Georgia, serif",
                  letterSpacing: "1px",
                }}
              >
                PIHAK II
              </div>

              <div
                style={{
                  height: 60,
                  width: 160,
                  borderBottom: "1px solid black",
                  margin: "0 auto",
                }}
              />

              <div style={{ marginTop: "4px" }}>( {namaPihakDua} )</div>
            </div>

            <div>
              <div
                style={{
                  fontFamily: "Georgia, serif",
                  letterSpacing: "1px",
                }}
              >
                PIHAK I
              </div>

              <div
                style={{
                  height: 60,
                  width: 160,
                  borderBottom: "1px solid black",
                  margin: "0 auto",
                }}
              />

              <div style={{ marginTop: "4px" }}>( {data.pihak1.nama} )</div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer aksi - tidak ikut ke-capture PDF */}
      <div
        style={{
          borderTop: "1px solid #E4DFD3",
          padding: "16px 40px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        {isCreated ? (
          <button
            disabled={isDownloading}
            style={{
              background: "#FBFAF7",
              color: "#1C2B39",
              border: "1px solid #B08D57",
              borderRadius: "3px",
              padding: "10px 20px",
              fontFamily: "Georgia, serif",
              letterSpacing: "0.5px",
              cursor: isDownloading ? "not-allowed" : "pointer",
            }}
            onClick={handleDownloadPdf}
          >
            {isDownloading ? "Menyiapkan PDF..." : "Download PDF"}
          </button>
        ) : (
          ""
        )}

        {!isCreated ? (
          <button
            className="button-kirim-absen"
            disabled={isDisabled}
            style={{
              background: isDisabled ? "#C9C2B2" : "#1C2B39",
              color: "#FBFAF7",
              border: "none",
              borderRadius: "3px",
              padding: "10px 28px",
              fontFamily: "Georgia, serif",
              letterSpacing: "0.5px",
              cursor: isDisabled ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              setIsDisabled(true);
              handleKirim();
            }}
          >
            Kirim
          </button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default FormContract;
